import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { BehaviorSubject, Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

import { DialogConfig, SnackBarConfig } from '../../../shared/configs';
import { OrderApiService } from '../../../shared/services';
import { ShippingLabelComponent } from '../shipping-label/shipping-label.component';
import { ShippingLabelDetailsComponent } from '../shipping-label-details/shipping-label-details.component';

@Component({
  selector: 'lum-shipping-label-popup',
  templateUrl: './shipping-label-popup.component.html',
  styleUrls: ['./shipping-label-popup.component.scss'],
})
export class ShippingLabelPopupComponent implements OnInit, OnDestroy {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>true);
  loading$ = this._loading.asObservable();

  private onDestroy$ = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data :{
      salesOrderId :number;
      withPackingSlip :boolean;
    },
    private orderApiService :OrderApiService,
    private snackbar :MatSnackBar,
    private dialog :MatDialog,
    private dialogRef :MatDialogRef<ShippingLabelPopupComponent>,
  ) {}

  ngOnInit() :void {
    this.initSalesOrder();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  private initSalesOrder() :void {
    this.orderApiService
      .getById(this.data?.salesOrderId, {
        relations: 'shipments,availableShippingLabel',
      })
      .pipe(
        finalize(() => {
          this._loading.next(false);
          this.dialogRef.close();
        }),
        takeUntil(this.onDestroy$),
      )
      .subscribe({
        next: (response :any) => {
          if (response?.hasShippingLabel) {
            this.openShippingLabelPreview();
          } else {
            this.openShippingLabelForm(response);
          }
        },
        error: (error) => {
          this.snackbar.open('Error loading sales order.', 'Error', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
      });
  }

  private openShippingLabelPreview() :void {
    this.dialog.open(ShippingLabelDetailsComponent, {
      data: this.data,
      width: 'auto',
    });
  }

  private openShippingLabelForm(order :any) :void {
    const {
      shipTo,
      shipDate,
      carrierCode,
      serviceCode,
      packageCode,
      weight,
      dimensions,
      confirmation,
    } = order;
    this.dialog
      .open(ShippingLabelComponent, {
        data: {
          salesOrderId: this.data?.salesOrderId,
          shipTo: shipTo,
          shipDate: shipDate,
          carrierCode: carrierCode,
          serviceCode: serviceCode,
          packageCode: packageCode,
          weight: weight,
          dimensions: dimensions,
          confirmation: confirmation,
          showPreview: true,
        },
        width: DialogConfig.sizes.medium,
      })
      .afterClosed()
      .subscribe((data :any) => {
        if (data) {
          this.openShippingLabelPreview();
        }
      });
  }
}
